import { h } from "omi";

export function QuizSkeleton() {
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <div className="h-8 bg-gray-700/30 rounded-md animate-pulse"></div>

        <div className="flex flex-col sm:flex-row justify-center gap-6 mb-6 bg-gray-700/30 px-4 py-2 rounded-lg w-fit mx-auto animate-pulse">
          <div className="flex items-center text-secondary text-sm space-x-1 opacity-100">
            <div className="w-5 h-5 bg-gray-700/40 rounded-full animate-pulse"></div>
            <div className="w-20 h-4 bg-gray-700/40 rounded-md animate-pulse"></div>
          </div>

          <div className="flex items-center text-secondary text-sm space-x-1 opacity-100">
            <div className="w-5 h-5 bg-gray-700/40 rounded-full animate-pulse"></div>
            <div className="w-16 h-4 bg-gray-700/40 rounded-md animate-pulse"></div>
          </div>
          <div className="flex items-center text-secondary text-sm space-x-1 opacity-100">
            <div className="w-5 h-5 bg-gray-700/40 rounded-full animate-pulse"></div>
            <div className="w-32 h-4 bg-gray-700/40 rounded-md animate-pulse"></div>
          </div>
        </div>
      </div>

      <div className="space-y-1">
        <div className="w-full h-4 bg-gray-700/30 rounded-md animate-pulse"></div>
        <div className="w-full h-4 bg-gray-700/30 rounded-md animate-pulse"></div>
        <div className="w-full h-4 bg-gray-700/30 rounded-md animate-pulse"></div>
        <div className="w-full h-4 bg-gray-700/30 rounded-md animate-pulse"></div>
      </div>
    </div>
  );
}
